module.exports = __webpack_public_path__ + "img/languageIcon.71799323.svg";